import React from "react";
import { Provider } from "react-redux";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { store } from "./Store/store";

type Props = {
    children: React.ReactNode;
};

const AppWrapper = ({ children }: Props) => {
    const queryClient = new QueryClient();
    return (
        <React.Suspense fallback={<div className="loading show"></div>}>
            <Provider store={store}>
                <QueryClientProvider client={queryClient}>
                    {children}
                </QueryClientProvider>
            </Provider>
        </React.Suspense>
    );
};

export default AppWrapper;